import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

import App from './App'
import store from './store'
import './index.css'
import { unregister } from './registerServiceWorker'

if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_DISABLE_SENTRY !== 'true'
) {
  console.log('init sentry')
  Sentry.init({
    dsn: 'https://86938465cfea41d0b1a90a79c6dcafb0@o1151860.ingest.sentry.io/6364804',
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    beforeBreadcrumb(breadcrumb, hint) {
      if (
        breadcrumb.category === 'ui.click' ||
        breadcrumb.category === 'ui.input' ||
        breadcrumb.category === 'console'
      ) {
        return null
      }
      return breadcrumb
    },
    tracesSampleRate: 1.0,
  })
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

unregister()
